import React, { useState, useRef, Fragment } from 'react'
import styled from 'styled-components'
import { useOnClickOutside } from '@services/layout'
import { Link } from 'react-router-dom'
import colors from '@constants/colors'
import { menuIcon } from '@assets/images'
import { useUser } from '@state/uses/users'
import { useHistory } from 'react-router-dom'
const dancesHE = 'ריקודים'
const myDancesHE = 'הריקודים שלי'
const usersHE = 'משתמשים'
const settingsHE = 'הגדרות'
const loginHE = 'התחברות'

export default () => {
    const user = useUser()
    const history = useHistory()

    const ref = useRef()
    const [menuIsOpen, setMenuIsOpen] = useState()
    const toggleMenu = () => {
        setMenuIsOpen(!menuIsOpen)
    }
    useOnClickOutside(ref, () => setMenuIsOpen(false))

    const goToMyDances = () => {
        history.push({
            pathname: '/dances',
            state: {
                searchByUser: {
                    id: user.user_id,
                    first_name: user.first_name,
                    last_name: user.last_name,
                },
            },
        })
    }
    const goToDances = () => {
        if (user?.is_admin) {
            history.push({
                pathname: '/dances',
                state: {
                    searchByOrderStratus: {
                        label: 'מוזמן',
                        value: 'מוזמן',
                    },
                },
            })
        } else {
            goToMyDances()
        }
    }

    return (
        <Wrapper ref={ref}>
            <MenuButton onClick={toggleMenu} />
            {menuIsOpen &&
                (user ? (
                    <Overlay>
                        <Menu>
                            <MenuItem
                                onClick={() => {
                                    setMenuIsOpen(false)
                                    goToDances()
                                }}>
                                <Link to="/dances">{dancesHE}</Link>
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    setMenuIsOpen(false)
                                    goToMyDances()
                                }}>
                                <Link to="/dances">{myDancesHE}</Link>
                            </MenuItem>
                            {user && user.is_admin && (
                                <Fragment>
                                    <MenuItem>
                                        <Link
                                            onClick={() => setMenuIsOpen(false)}
                                            to="/users">
                                            {usersHE}
                                        </Link>
                                    </MenuItem>
                                    <MenuItem>
                                        <Link
                                            onClick={() => setMenuIsOpen(false)}
                                            to="/settings">
                                            {settingsHE}
                                        </Link>
                                    </MenuItem>
                                </Fragment>
                            )}
                        </Menu>
                    </Overlay>
                ) : (
                    <Overlay>
                        <Menu>
                            <MenuItem onClick={() => setMenuIsOpen(false)}>
                                <Link to="/login">{loginHE}</Link>
                            </MenuItem>
                            <MenuItem onClick={() => setMenuIsOpen(false)}>
                                <Link to="/">ראשי</Link>
                            </MenuItem>
                        </Menu>
                    </Overlay>
                ))}
        </Wrapper>
    )
}

const Wrapper = styled.div`
    position: relative;
    z-index: 1000;
    @media (min-width: 768px) {
        display: none;
    }
`

const MenuButton = styled.div`
    width: 50px;
    height: 50px;
    position: relative;
    background-size: 32px;
    background-position: 50%;
    background-repeat: no-repeat;
    background-image: url(${menuIcon});
`

const Overlay = styled.div`
    // position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(102, 51, 153, 0.41);
`

const Menu = styled.div`
    right: 0px;
    padding: 4px 0;
    min-width: 156px;
    position: absolute;
    background-color: ${colors.COLOR_PRIMARY};
`

const MenuItem = styled.div`
    padding: 8px 16px;
    & a,
    a:hover {
        color: #ffffff;
        text-decoration: none;
    }
`
